import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
// Api
import { CREATE_TICKET_EVENT } from 'api/ticketing/mutations';
// Types
import {
  CreateTicketEvent,
  CreateTicketEventVariables,
} from 'api/ticketing/types/CreateTicketEvent';
import { CreateTicketEventInput } from 'api/graphql-global-types';

export type CreatedTicketEvent = { id: string; version: number };

export type CreateTicketEventFn = (
  input: CreateTicketEventInput
) => Promise<CreatedTicketEvent>;

export const useCreateTicketEvent = (): CreateTicketEventFn => {
  const [createTicketEvent] = useMutation<
    CreateTicketEvent,
    CreateTicketEventVariables
  >(CREATE_TICKET_EVENT);

  return useCallback<CreateTicketEventFn>(
    async (input) => {
      const { data } = await createTicketEvent({ variables: { input } });

      if (!data) {
        throw new Error('The event was not created');
      }

      return {
        id: data.createTicketEvent.id,
        version: data.createTicketEvent.version,
      };
    },
    [createTicketEvent]
  );
};
